export default __webpack_public_path__ + "static/media/logo-horizontal.053666d1.svg";